import { render, staticRenderFns } from "./ModalAddBenhAn.vue?vue&type=template&id=72bfb8ca&scoped=true"
import script from "./ModalAddBenhAn.vue?vue&type=script&lang=js"
export * from "./ModalAddBenhAn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bfb8ca",
  null
  
)

export default component.exports